export default "__VITE_ASSET__CLBUN1b8__"